import { arraysOverlap } from '@utils/arrays';

export const validateAvailabilityByBooleanOrRoles = (engineResult: boolean | string[], roles: string[]) => {
  if (engineResult && Array.isArray(engineResult)) {
    return arraysOverlap(engineResult ?? [], roles ?? []);
  }
  return !!engineResult;
};
